<template>

  <div class="my-profile">
    <div class="columns">
      <div class="column">
        <h2 class="title is-4">
          Profile Documents
        </h2>
      </div>
    </div>
    <div v-if="msg.length" class="columns">
      <div class="column">
        <div class="notification is-info">
          <button class="delete" @click="msg = ''"></button>
          {{ msg }}
        </div>
      </div>
    </div>

    <template v-if="!selectedDoc">
      <section style="padding: 10px;">
        <b-table
          :data="documents"
          :bordered="false"
          :striped="true"
          :narrowed="false"
          :hoverable="true"
          :loading="false"
          :focusable="false"
          :mobile-cards="false"
          :selected.sync="selectedDoc">

          <template slot-scope="props">
            <b-table-column field="name" label="name">{{ props.row.name }}</b-table-column>
            <b-table-column field="issuedDate" label="Issued Date" centered>{{ formatDate(props.row.dateIssued) }}</b-table-column>
            <b-table-column field="expiryDate" label="Expiry Date" centered>{{ formatDate(props.row.dateExpire) }}</b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>NO DOCUMENTS</p>
              </div>
            </section>
          </template>
        </b-table>
      </section>
    </template>

    <template v-else>
      <div class="columns">
        <div class="column">
          <div class="box">
            <profile-document :doc="selectedDoc"></profile-document>
            <hr />
            <button class="button" @click="selectedDoc = null">Close</button>
          </div>
        </div>
      </div>
    </template>
    <!-- <button class="button is-success" @click="selectedDoc = undefined">Add Document</button> -->

  </div>

</template>

<script>
import ProfileDocument from '../components/ProfileDocument'
// import EmployeeProfile from '../components/EmployeeProfile'

export default {
  name: 'MyProfile',
  components: {
    ProfileDocument
  },
  data () {
    return {
      msg: '',
      documents: [],
      selectedDoc: null
    }
  },
  watch: {
    selectedDoc () {
      console.log('selected', this.selectedDoc)
    }
  },
  computed: {
    user () { return this.$store.getters.user }
  },
  created () {
    this.subs.profileDocuments = this.$firestore.collection('profile-documents')
      .where('uid', '==', this.user.uid)
      .onSnapshot(snapshot => {
        this.documents = this.$utils.snapshotToArr(snapshot)
      })
  },
  methods: {
    selectDoc (doc) {
      this.selectedDoc = JSON.parse(JSON.stringify(doc))
    },
    formatDate (unixTimestamp) {
      return unixTimestamp ? this.$moment.unix(unixTimestamp).format('DD/MM/YYYY') : '' + unixTimestamp
    }
  }
}
</script>
